module.exports = __webpack_public_path__ + "static/media/3d.84313158.png";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Create/NewResource/images/3d.png
// module id = 1216
// module chunks = 2